import { render } from "./Menu.vue?vue&type=template&id=021a4e28&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=021a4e28&scoped=true&lang=css"

import exportComponent from "/opt/stagecoach/apps/pa-wildflower-selector/deployments/2022-05-18-09-54-08/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021a4e28"]])

export default __exports__